import { Box, Stack, Typography } from '@mui/material';

import { Medallion } from '@/components/display/Medallion/Medallion';
import { LayersThree01Icon } from '@/components/icons/LayersThree01Icon';
import { COLORS } from '@/styles/tokens/colors';

/**
 * Settings panel for the EditableCallout component.
 *
 * Since the callout is now a container for other blocks (rather than having
 * its own text prop), this panel just shows guidance on how to use it.
 * The delete action is still accessible via the toolbar.
 */
export function EditableCalloutSettings() {
  return (
    <Stack spacing={2} alignItems="center" py={2}>
      <Medallion
        size={48}
        icon={<LayersThree01Icon size={24} />}
        colors={{
          background: COLORS.GRAY[200],
          iconColor: COLORS.TEXT.SECONDARY,
        }}
      />
      <Box textAlign="center" px={2}>
        <Typography variant="body-xs">
          Drag blocks from the sidebar into this callout
        </Typography>
      </Box>
    </Stack>
  );
}
